import { css } from '@emotion/core';
import { MediaQueries } from '../../../styles/Grid';
import { colorsPalette } from '../../../styles/colors';
import { typography } from '../../../styles/typography';

export const containerMarginCss = css({
  marginBottom: 55,
});

export const containerPaddingCss = css({
  paddingBottom: 32,
});

export const containerCss = css({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  [MediaQueries.mdAndUp]: {
    justifyContent: 'flex-start',
  },
  section: {
    '&:last-of-type': {
      div: {
        [MediaQueries.mdAndUp]: {
          marginRight: 0,
        },
      },
    },
  },
});

export const titleCss = css(typography.effra34, {
  color: colorsPalette.grey,
});
